import { render, staticRenderFns } from "./addRecordYouthToSquad.vue?vue&type=template&id=1a80acac&scoped=true&"
import script from "./addRecordYouthToSquad.vue?vue&type=script&lang=js&"
export * from "./addRecordYouthToSquad.vue?vue&type=script&lang=js&"
import style0 from "./addRecordYouthToSquad.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./addRecordYouthToSquad.vue?vue&type=style&index=1&id=1a80acac&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a80acac",
  null
  
)

export default component.exports